import React, { createContext, useContext, useEffect, useState } from "react";
import { getIdentifier } from "../utils/auth";

const AuthCtx = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  logout: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://squid-app-6s2hc.ondigitalocean.app/whoami", {
        method: "GET",
        credentials: "include",
      });

      const data = await res.json().catch(() => ({}));

      if (data.loggedIn) {
        setUser({
          email: data.email || "",
          username: data.username || "",
        });
        return;
      }

      // Legacy fallback (identity hint, NOT real auth)
      const id = getIdentifier();
      if (id) setUser({ email: id, username: "" });
      else setUser(null);
    } catch {
      const id = getIdentifier();
      if (id) setUser({ email: id, username: "" });
      else setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    setLoading(true);
    try {
      await fetch("https://squid-app-6s2hc.ondigitalocean.app/logout", {
        method: "POST",
        credentials: "include",
      });
    } catch {
      // ignore
    } finally {
      setUser(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
